import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const CountUrl = `${Base_Url}/Dashboard`;

export const GetUserDashboardCountModel = async (UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${CountUrl}/GetUserDashboardCountModel?UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetUserActivityLogList = async (params) => {
  const res = await postApiWithAuthorization(
    `${CountUrl}/GetUserActivityLogList`,
    params
  );
  return res;
};
